import * as React from 'react'

const SubscriptionIcon = ({
  width = 24,
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={width}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    {...props}>
    <path
      d='M9 10.5L11 12.5L15.5 8M20 12.75V7.8C20 6.11984 20 5.27976 19.673 4.63803C19.3854 4.07354 18.9265 3.6146 18.362 3.32698C17.7202 3 16.8802 3 15.2 3H8.8C7.11984 3 6.27976 3 5.63803 3.32698C5.07354 3.6146 4.6146 4.07354 4.32698 4.63803C4 5.27976 4 6.11984 4 7.8V21L6.75 19L9.25 21L12 19L13.375 20M22 18.3333C22 18.3333 21.3668 17.4227 20.8525 16.8794C20.3381 16.3361 19.6273 16 18.8421 16C17.2725 16 16 17.3431 16 19C16 20.6569 17.2725 22 18.8421 22C19.6838 22 20.4401 21.6137 20.9605 21M20.1053 18.3333H22V16.3333'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default SubscriptionIcon
